export const getRelatedApps = (state: AnyFixMe) => state.relatedApps.value;
export const isRelatedAppsLoading = (state: AnyFixMe) =>
  state.relatedApps.isLoading;
